// src/ChatBot.js
import React, { useState } from 'react';
import '../BitsStyles/AIBot.css';

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false); // To control the visibility of the chat window
  const [messages, setMessages] = useState([
    { sender: 'bot', text: 'Hello! How can I assist you today?' }
  ]); // Store the conversation

  // Function to toggle the chat window
  const toggleChatWindow = () => {
    setIsOpen(!isOpen);
  };

  // Function to handle user input
  const handleUserInput = (event) => {
    event.preventDefault();
    const userInput = event.target.elements.userInput.value.trim();
    if (userInput === '') return;

    // Add user message to chat
    setMessages([...messages, { sender: 'user', text: userInput }]);
    event.target.reset();

    // Add bot's response (Here, we simulate the bot with simple responses)
    setTimeout(() => {
      const botResponse = getBotResponse(userInput);
      setMessages((prevMessages) => [
        ...prevMessages,
        { sender: 'bot', text: botResponse }
      ]);
    }, 1000);
  };

  // Enhanced function to return bot's responses based on user input
  const getBotResponse = (input) => {
    const lowerInput = input.toLowerCase();

    // Greetings
    if (lowerInput.includes('hello') || lowerInput.includes('hi')) {
      return 'Hello! How can I assist you today?';
    } else if (lowerInput.includes('good morning')) {
      return 'Good Morning! How can I help you today?';
    } else if (lowerInput.includes('good after noon')) {
      return 'Good Noon! How can I help you today?';
    } else if (lowerInput.includes('good evening')) {
      return 'Good Evening! How can I help you today?';
    } else if (lowerInput.includes('aslamualailkum')) {
      return 'Wa Alaikum Assalam! How can I assist you today?';

    // Company Info
    } else if (lowerInput.includes('website') || lowerInput.includes('about this company')) {
      return 'We are Bellary Info Tech Solutions, providing innovative webiste development,web applications,mobile applications and Billing Solutions.';
    } else if (lowerInput.includes('company name')) {
      return 'Our company is Bellary Info Tech Solutions.';
    } else if (lowerInput.includes('company start date') || lowerInput.includes('when did you start')) {
      return 'We started our journey in 2024.';
    } else if (lowerInput.includes('address') || lowerInput.includes('address of company')) {
      return 'Our office is located at Plot No 7, Ward No 18/21, Kappagal Road, M V Nagar 9th Cross, Bellary 583103, India.';
    } else if (lowerInput.includes('ceo') || lowerInput.includes('who is the ceo')) {
      return 'Our CEO is Mr Avulapati Srinivasulu .';
    } else if (lowerInput.includes('contact number') || lowerInput.includes('phone number') || lowerInput.includes('ceo contact')) {
      return 'You can reach our CEO, Mr. Avulapati Srininvasulu, at +91 9603299266.';
    }

    // Customer Support
    else if (lowerInput.includes('customer support') || lowerInput.includes('help') || lowerInput.includes('support')) {
      return (
        'Our customer support is available 24/7. You can reach us at:\n' +
        'Support Phone: +91-9703299266\n' +
        'Email: info@bellaryinfotech.com\n' +
        'WhatsApp: +91-9603299266\n' +
        'We are here to assist you at any time.'
      );
    } else if (lowerInput.includes('whatsapp')) {
      return 'You can reach us on WhatsApp at +91-9603299266 for quick assistance.';
    }

    // Services Offered
    else if (lowerInput.includes('services') || lowerInput.includes('services')) {
      return (
        'We offer a variety of services, including:\n' +
        '1. Mobile Development\n' +
        '2. Web Application Development\n' +
        '3. Website Design & Development\n' +
        '4. IT Support\n' +
        '5. Software Development\n' +
        '6. Billing Solutions\n' +
        'Please let us know if you need more details about any of these services.'
      );
    }

    // Business Hours
    else if (lowerInput.includes('business hours') || lowerInput.includes('working hours')) {
      return 'Our business hours are Monday to Friday, from 9 AM to 6 PM (IST). We are closed on weekends.';
    }

    // Call Back Request
    else if (lowerInput.includes('call back') || lowerInput.includes('schedule a call')) {
      return 'Please share your contact details and preferred time, and our team will get back to you as soon as possible.';
    }

    // Default response for unrecognized input
    else {
      return "Sorry, I didn't quite understand that. Could you please rephrase or ask something else?";
    }
  };

  return (
    <div>
      {/* Chatbot button */}
      <div className="chatbot-button" onClick={toggleChatWindow}>
        <img src="https://img.icons8.com/ios-filled/50/000000/chat.png" alt="chatbot" />
      </div>

      {/* Chat window */}
      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <h3>Chat with Us</h3>
            <button className="close-btn" onClick={toggleChatWindow}>
              X
            </button>
          </div>

          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`message ${msg.sender === 'user' ? 'user-message' : 'bot-message'}`}
              >
                {msg.text}
              </div>
            ))}
          </div>

          <form className="chatbot-input" onSubmit={handleUserInput}>
            <input
              type="text"
              name="userInput"
              placeholder="Type your message..."
              autoComplete="off"
              required
            />
            <button type="submit">Send</button>
          </form>
        </div>
      )}
    </div>
  );
};

export default ChatBot;
